import { inject, Pipe, PipeTransform } from '@angular/core';
import { ShortNumberPipe } from './short-number.pipe';

@Pipe({
  name: 'impressionsRangePipe'
})
export class ImpressionsRangePipe implements PipeTransform {

  private shortNumberPipe = inject(ShortNumberPipe)

  transform(minImpressions: number, maxImpressions: number): string {
    if (typeof minImpressions !== 'number' || typeof maxImpressions !== 'number') {
      return '';
    }
    if(maxImpressions <= 100){
      return '<100';
    }
    if(minImpressions >= 25_000_000){
      return '>25M'
    }
    return `${this.shortNumberPipe.transform(minImpressions)}-${this.shortNumberPipe.transform(maxImpressions)}`;
  }
}
